var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6H18V16C18 17.1046 17.1046 18 16 18H6V8C6 6.89543 6.89543 6 8 6ZM24 6H34V16C34 17.1046 33.1046 18 32 18H22V8C22 6.89543 22.8954 6 24 6ZM18 22H8C6.89543 22 6 22.8954 6 24V34H16C17.1046 34 18 33.1046 18 32V22ZM23.75 21.75H34V32C34 33.1046 33.1046 34 32 34H21.75V23.75C21.75 22.6455 22.6454 21.75 23.75 21.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGrid);
export default __webpack_public_path__ + "static/media/ico-grid.78b1c00b77efb6abb75bfd7b3a8a8532.svg";
export { ForwardRef as ReactComponent };